import IconComponent from "icons/IconComponent";

import ExpandIcon from "./expand.svg";

export default (ExpandIcon as any) as IconComponent;
